import React, { useEffect, useState, useLayoutEffect } from "react";
import ReactImageLightbox from "react-image-lightbox"; // Install this for pop-up functionality
import "react-image-lightbox/style.css"; // Style for the image pop-up
import PageTitle from "../banner";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../config/fbconfig";
import { useLocation } from "react-router-dom";

function Clicks() {
  const location = useLocation();
  const { category } = location.state || {}; // Retrieving category from state

  const [activeFilter, setActiveFilter] = useState(
    category ? category : "Birdings"
  ); // Default filter
  const [isOpen, setIsOpen] = useState(false); // For lightbox modal
  const [currentImage, setCurrentImage] = useState(""); // Track the current image for modal
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagesLoading, setImagesLoading] = useState(true);

  const openModal = (imgSrc) => {
    setCurrentImage(imgSrc);
    setIsOpen(true);
  };

  useEffect(() => {
    // Update active filter when the category is passed from useLocation
    if (category) {
      setActiveFilter(category);
    }
  }, [category]); // This runs whenever `category` changes

  useEffect(() => {
    const fetchClicks = async () => {
      setLoading(true);
      setImagesLoading(true);
      try {
        const docRef = doc(db, "Clicks", activeFilter); // Use activeFilter to get the right data
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const fetchedData = [];
          Object.entries(docSnap.data()).forEach(([key, value]) => {
            fetchedData.push(Object.assign({ Id: key }, value));
          });
          setData(fetchedData.sort((a, b) => a.Priority - b.Priority));
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      } finally {
        setLoading(false);
      }
    };

    if (activeFilter) {
      fetchClicks(); // Call the API when activeFilter changes
    }
  }, [activeFilter]); // This effect runs whenever activeFilter changes

  const handleImageLoad = () => {
    setImagesLoading(false);
  };

  const getInitialBgImage = () =>
    window.innerWidth <= 768
      ? "img/about/clicksmb.jpg"
      : "img/about/banner.jpg";

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bgImage, setBgImage] = useState(getInitialBgImage);

  useLayoutEffect(() => {
    const handleResize = () => {
      setBgImage(
        window.innerWidth <= 768
          ? "img/about/clicksmb.jpg"
          : "img/about/banner.jpg"
      );
      setIsMobile(window.innerWidth <= 768);
    };

    const debounceResize = debounce(handleResize, 100);

    window.addEventListener("resize", debounceResize);
    return () => {
      window.removeEventListener("resize", debounceResize);
    };
  }, []);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  return (
    <div>
      <div style={{ marginBottom: "2.1rem" }}>
        <PageTitle desc={"Clicks"} img={bgImage} />
      </div>
      <div className="gallery-section spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="filter-controls">
                <ul>
                  <li
                    className={activeFilter === "Birdings" ? "active" : ""}
                    onClick={() => setActiveFilter("Birdings")}
                    style={{ paddingRight: "4px" }}
                  >
                    Birding
                  </li>
                  <li
                    className={activeFilter === "BigCats" ? "active" : ""}
                    onClick={() => setActiveFilter("BigCats")}
                    style={{
                      paddingRight: isMobile ? "4px" : "",
                      paddingLeft: isMobile ? "4px" : "",
                    }}
                  >
                    Big Cats
                  </li>
                  <li
                    className={activeFilter === "WildLife" ? "active" : ""}
                    onClick={() => setActiveFilter("WildLife")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Wild Life
                  </li>
                  <li
                    className={activeFilter === "Landscapes" ? "active" : ""}
                    onClick={() => setActiveFilter("Landscapes")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Landscape
                  </li>
                  <li
                    className={activeFilter === "People" ? "active" : ""}
                    onClick={() => setActiveFilter("People")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Portrait
                  </li>
                  <li
                    className={activeFilter === "Mobilography" ? "active" : ""}
                    onClick={() => setActiveFilter("Mobilography")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Mobilography
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              {loading ? (
                <div className="loading-indicator">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : data.length === 0 ? (
                <div
                  className="no-data-message"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h5>No data found</h5>
                </div>
              ) : (
                <div className="gallery-filter row">
                  {data?.map((item, index) => (
                    <div
                      key={index}
                      className="col-xs-6 col-sm-4 col-md-3 col-lg-3 mb-3"
                      style={{ padding: 0 }}
                    >
                      <div
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          width: "100%",
                          height: "400px",
                          padding: "5px",
                        }}
                      >
                        {imagesLoading && (
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          >
                            {/* Green circular loader */}
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                border: "4px solid #f3f3f3", // Light grey
                                borderTop: "4px solid green", // Green color
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite",
                              }}
                              role="status"
                            >
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        )}
                        <img
                          src={item.Image}
                          alt={item.category}
                          className="img-fluid"
                          style={{
                            objectFit: "cover",
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                            visibility: imagesLoading ? "hidden" : "visible",
                          }}
                          onLoad={handleImageLoad}
                          onClick={(e) => {
                            e.preventDefault();
                            openModal(item.Image);
                          }}
                        />
                        <a
                          href={item.Image}
                          onClick={(e) => {
                            e.preventDefault();
                            openModal(item.Image);
                          }}
                        ></a>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="container" style={{ marginTop: "3rem" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="filter-controls">
                <ul>
                  <li
                    className={activeFilter === "Birdings" ? "active" : ""}
                    onClick={() => setActiveFilter("Birdings")}
                    style={{ paddingRight: "4px" }}
                  >
                    Birding
                  </li>
                  <li
                    className={activeFilter === "BigCats" ? "active" : ""}
                    onClick={() => setActiveFilter("BigCats")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    &nbsp; Big Cats
                  </li>
                  <li
                    className={activeFilter === "WildLife" ? "active" : ""}
                    onClick={() => setActiveFilter("WildLife")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Wild Life
                  </li>
                  <li
                    className={activeFilter === "Landscapes" ? "active" : ""}
                    onClick={() => setActiveFilter("Landscapes")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Landscape
                  </li>
                  <li
                    className={activeFilter === "People" ? "active" : ""}
                    onClick={() => setActiveFilter("People")}
                    style={{ paddingRight: "4px", paddingLeft: "4px" }}
                  >
                    Portrait
                  </li>
                  <li
                    className={activeFilter === "Mobilography" ? "active" : ""}
                    onClick={() => setActiveFilter("Mobilography")}
                    style={{ paddingLeft: "4px" }}
                  >
                    Mobilography
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOpen && (
        <ReactImageLightbox
          mainSrc={currentImage}
          onCloseRequest={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

export default Clicks;
